<div class="catalogue-container">
  <div class="catalogue-title">
    {{ 'CATALOGUE.TITLE' | translate }}
  </div>

  <div
    class="catalogue-text"
    [innerHTML]="'CATALOGUE.CHOOSE-CATEGORY-OPTIONAL' | translate"
  ></div>

  <div class="training-categories-container">
    <dx-drop-down-box
      [(value)]="trainingCategoryIds"
      [inputAttr]="{ 'aria-label': 'Owner' }"
      valueExpr="id"
      displayExpr="name"
      [label]="getTrainingCategoryLabel"
      [dataSource]="trainingCategories"
      [readOnly]="isViewMode"
      labelMode="floating"
      stylingMode="outlined"
    >
      <div *dxTemplate="let data of 'content'">
        <dx-tree-view
          [searchEnabled]="true"
          [dataSource]="trainingCategories"
          dataStructure="plain"
          keyExpr="id"
          selectionMode="multiple"
          showCheckBoxesMode="normal"
          [selectNodesRecursive]="false"
          displayExpr="name"
          [selectByClick]="true"
          (onItemSelectionChanged)="onTrainingCategorySelected($event)"
        ></dx-tree-view>
      </div>
    </dx-drop-down-box>
  </div>

  @if (trainingCategoryIds.length === 0) {
    <div class="info-container not-listed-container">
      <i
        class="dx-icon dx-svg-icon"
        [innerHTML]="getMinusCircleIcon()"
      ></i>
      <span
        [innerHTML]="'CATALOGUE.NOT-LISTED-WARNING' | translate"
      ></span>
    </div>
  } @else {
    <div class="info-container training-catalogue-container">
      <i
        class="dx-icon dx-svg-icon"
        [innerHTML]="getBookIcon()"
      ></i>
      <span [innerHTML]="getTrainingCatalogueText()"></span>
    </div>
  }
</div>